import DashboardWithOpenSideNav from "components/Layout/DashboardWithOpenSideNav/DashboardWithOpenSideNav";
import { Route } from "react-router-dom";
import { customQuereiesDrawerElements } from "components/CustomQueriesDashboard/data";
import CustomQueriesDashboard from "components/CustomQueriesDashboard/CustomQueriesDashboard";

export const generateCustomQueriesRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types) {
		const defaultRoute = Object.values(service.types)[0];
		return (
			<Route key={service.key} path={service.key}>
				<Route
					index
					element={
						<DashboardWithOpenSideNav
							drawerList={customQuereiesDrawerElements}
							navSpace={0}
							service={defaultRoute}
							pathName={defaultRoute.key}
							rootPath={rootPath}
							drawerWidth={280}
						/>
					}
				/>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateCustomQueriesRoutesFromServiceTree(service.types[childKey], rootPath)
					)}
			</Route>
		);
	} else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardWithOpenSideNav
						drawerList={customQuereiesDrawerElements}
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						drawerWidth={280}
					/>
				}>
				<Route index element={<CustomQueriesDashboard />} />
			</Route>
		);
};
